export default "__VITE_ASSET__cb50db92__"